class Localizer {
  // - identifier: string bcp47
  // - region: string "US" | "GB" | ...
  // - calendar: string "gregory" | "japanese" | "buddhist" | ...
  // - hour12: bool
  // - metricSystem: bool
  // - temperatureUnit: string "celsius" | "fahrenheit"
  // - currencies: string[] ["USD" | ...]
  // - timeZone: string "US/Eastern" | ...
  locale = null;

  translate(msgId, values) {}

  t = (msgId, values) => {
    return this.translate(msgId, values);
  };

  formatDateTime(date, options) {}

  formatNumber(value, options) {}
}

export default Localizer;
